/* eslint-disable import/no-extraneous-dependencies */
import ReactGA from 'react-ga4';

import { NEXT_PUBLIC_GTAG_ID } from 'config';

export interface TEvent {
  category: string;
  action: string;
  label?: string;
  value?: number;
  nonInteraction?: boolean;
  transport: 'image' | 'xhr' | 'beacon' | undefined;
}

export interface IEventHandler {
  sendEvent: (event: TEvent) => void;
}

ReactGA.initialize(String(NEXT_PUBLIC_GTAG_ID));

export const sendEvent = (event: string, options: any): any => {
  ReactGA.event(event, options);
  return {
    sendEvent,
  };
};

export const sendComplexEvent = (options: TEvent): any => {
  const { category, action, label, value, nonInteraction, transport } = options;
  ReactGA.event({
    category,
    action,
    label, // optional
    value, // optional, must be a number
    nonInteraction, // optional, true/false
    transport, // optional, beacon/xhr/image
  });
  return {
    sendComplexEvent,
  };
};

export default { sendEvent, sendComplexEvent };
